export type LocalizedText = Record<string, string>;

export const DEFAULT_LANGUAGE_CODES = ['de', 'en'] as const;

export function emptyLocalizedText(languageCodes: string[] = [...DEFAULT_LANGUAGE_CODES]): LocalizedText {
  return Object.fromEntries(languageCodes.map((code) => [code, '']));
}
